import { render, staticRenderFns } from "./RemarkDialog.vue?vue&type=template&id=36751818&scoped=true"
import script from "./RemarkDialog.vue?vue&type=script&lang=js"
export * from "./RemarkDialog.vue?vue&type=script&lang=js"
import style0 from "./RemarkDialog.vue?vue&type=style&index=0&id=36751818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36751818",
  null
  
)

export default component.exports